var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconakarPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.327,
    height: 33.131,
    viewBox: "0 0 29.327 33.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_akar-person",
    "data-name": "Icon akar-person",
    transform: "translate(-3.393 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M25.565,10.533A7.533,7.533,0,1,1,18.033,3a7.533,7.533,0,0,1,7.533,7.533Z",
    transform: "translate(0.024 0)",
    fill: "none",
    stroke: "#98c6c4",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M25.59,21h.53A4.52,4.52,0,0,1,30.6,24.959l.589,4.706a3.013,3.013,0,0,1-2.99,3.387H7.912a3.013,3.013,0,0,1-2.99-3.387l.588-4.706A4.52,4.52,0,0,1,10,21h.529",
    transform: "translate(0 0.078)",
    fill: "none",
    stroke: "#98c6c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconakarPerson);
export default __webpack_public_path__ + "static/media/Icon akar-person.364d4ac3cb4b6328401456b3fed8db62.svg";
export { ForwardRef as ReactComponent };